(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('solicitante', {
            parent: 'entity',
            url: '/solicitante?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'chamadosApp.solicitante.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/solicitante/solicitantes.html',
                    controller: 'SolicitanteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('solicitante');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('solicitante.new', {
            parent: 'solicitante',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/solicitante/solicitante-dialog.html',
                    controller: 'SolicitanteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                projetoRedMine: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('solicitante', null, { reload: 'solicitante' });
                }, function() {
                    $state.go('solicitante');
                });
            }]
        })
        .state('solicitante.edit', {
            parent: 'solicitante',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/solicitante/solicitante-dialog.html',
                    controller: 'SolicitanteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Solicitante', function(Solicitante) {
                            return Solicitante.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('solicitante', null, { reload: 'solicitante' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();
